export default {
  title: "Hong Kong Pack",
  location: "Tsim Tsa Tsui, Mongkok, Central",
  liked: true,
  ecoMetrics: {
    green: "50%"
  },
  checkpoints: [{
    imgSrc: "imgs/photo_hongkong_1.jpg",
    rank: "#1st Destination",
    title: "Title Placeholder",
    location: "location placeholder"
  },{
    imgSrc: "imgs/photo_hongkong_2.jpg",
    rank: "#1st Destination",
    title: "Title Placeholder",
    location: "location placeholder"
  },{
    imgSrc: "imgs/photo_hongkong_3.jpg",
    rank: "#1st Destination",
    title: "Title Placeholder",
    location: "location placeholder"
  },
],
  reviewer: {
    imgSrc: "imgs/profile-pic.png",
    name: "Oea Romana",
    location: "Traveller based in UK"
  },
  description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  transitions: [{
    from: 'Hong Kong Space Museum',
    to: 'Montane Mansion',
    description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor'
  },{
    from: 'Montane Mansion',
    to: 'Choi Hung Estate',
    description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor'
  },],
  mapImgSrc: 'https://via.placeholder.com/374x284',
  totalPrice: 100,
}
